import FeatureGates from '@atlaskit/feature-gate-js-client';

import { useBooleanFeatureFlag } from '@confluence/session-data';

export enum Cohort {
	CONTROL = 'control',
	EXPERIMENT = 'experiment',
}

const EXPERIMENT_NAME = 'confluence_feed_without_comment';
const COHORT = 'cohort';

export const useFeedShouldHideComments = () => {
	const isFeedWithoutCommentsEnabled = useBooleanFeatureFlag(
		'confluence.frontend.feed.no-comments',
	);
	if (!isFeedWithoutCommentsEnabled) {
		return false;
	}
	const cohort: string = FeatureGates.getExperimentValue<string>(
		EXPERIMENT_NAME,
		COHORT,
		Cohort.CONTROL,
	);

	if (cohort === Cohort.EXPERIMENT) {
		return true;
	}
	return false;
};
